// @flow

export const DEFAULT_PHASE = 'golive';
